module.exports = __webpack_public_path__ + "static/media/texture (12).b0d12679.jpg";